import AIChart from "../AIChart";
import type { AIChart as AIChartData } from "../../types/ai.types";

/**
 * Chart card for the live call — a chart pushed over `ai:voice:chart`
 * (run_report chart=… / render_chart). Same glass card as RecordingCard;
 * the × closes it locally (the call is unaffected).
 */
export default function ChartCard({ chart, language, onDismiss }: { chart: AIChartData; language: "ml" | "en"; onDismiss: () => void }) {
  const ml = language === "ml";
  return (
    <div className="xv-rec" style={{ display: "block" }}>
      <div className="xv-rec-top" style={{ alignItems: "flex-start" }}>
        <div className="xv-rec-meta" style={{ flex: 1, minWidth: 0 }}>
          <div className="xv-rec-title">{chart.title}</div>
          <div className="xv-rec-sub">{ml ? "ഗ്രാഫ്" : "Chart"}</div>
        </div>
        <button className="xv-pill is-icon" onClick={onDismiss} aria-label={ml ? "അടയ്ക്കുക" : "Close"} title={ml ? "അടയ്ക്കുക" : "Close"}>
          ×
        </button>
      </div>
      <div style={{ marginTop: 8 }}>
        <AIChart chart={chart} dark height={260} />
      </div>
    </div>
  );
}
